import { Injectable } from '@angular/core';
import { HttpService } from '../../core/lib/http.service'
import { OthersService } from '../../services/others/others.service'

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  private apiurl: string;
  constructor(private httpservice: HttpService, private otherService: OthersService) {
    this.apiurl = otherService.getApiUrl();
  }

  getHistory(id,param:object) {
    return this.httpservice.get(this.apiurl + '/v3/company/' + id + '/history', param);
  }

  async getComCardStats(id) {
    return this.httpservice.get(this.apiurl + '/v3/company/' + id + '/stats/exchange', {});
  }

  async getTotalStats(id) {
    return this.httpservice.get(this.apiurl + '/v3/company/' + id + '/stats/total', {});
  }

  async getTotalCardStats(id) {
    return this.httpservice.get(this.apiurl + '/v3/company/' + id + '/cardtotal', {});
  }


  async getTotalStaffStats(id) {
    return this.httpservice.get(this.apiurl + '/v3/staff/' + id + '/stats/total', {});
  }

  async getStats(id) {
    return this.httpservice.get(this.apiurl + '/v3/company/' + id + '/stats', {});
  }

  async getStats2(id) {
    return this.httpservice.get(this.apiurl + '/v3/company/' + id + '/top', {});
  }

  async getConnects(id) {
    return this.httpservice.get(this.apiurl + '/v3/company/' + id + '/stats/connects', {});
  }


  async getCardSharingStats(id) {
    return this.httpservice.get(this.apiurl + '/v3/company/' + id + '/stats/sharing', {});
  }
}
